import { gql } from "@apollo/client";

export const VPS_PACKAGES = gql`
  query ($is_custom: Boolean) {
    proxmox {
      ip_availability
      packages(is_custom: $is_custom, status: [1]) {
        nodes {
          id
          name
          is_active
          is_custom
          package_pricings {
            id
            package_id
            duration
            price
            discount_promo
            reseller_package_pricing {
              id
              reseller_level
              reseller_price
            }
          }
          service_plan_attributes {
            id
            key
            value
          }
        }
      }
      os_batch {
        nodes {
          id
          name
          is_active
        }
      }
      cpanels {
        nodes {
          id
          name
          price
        }
      }
    }
  }
`;

export const VPS_LIST = gql`
  query ($limit: Int!, $page: Int!, $sort_by: String) {
    proxmox {
      vps_batch(limit: $limit, page: $page, sort_by: $sort_by) {
        page
        total_data
        nodes {
          id
          name
          register_date
          expired_date
          status
          host_name
          package_pricing {
            id
            price
            duration
            package_id
            discount_promo
          }
          operating_system {
            id
            name
            is_active
          }
        }
      }
      os_batch {
        nodes {
          id
          name
          is_active
        }
      }
    }
  }
`;

export const CREATE_CART_VPS = gql`
  mutation createCart($input: CloudbankCreateCartVps!) {
    billing {
      cartOps {
        create_cart_vps(input: $input) {
          id
          qty
          user_id
          name
          status
          db
          package_extension_id
          package_pricing_id
          price
          package_pricing_duration
          package {
            id
            name
            status
          }
          vps_package_name
          cpanel
        }
      }
    }
  }
`;

export const VPS_KEY_CRED = gql`
  query {
    proxmox {
      key_credentials_by_token {
        id
        name
        public
        user_id
      }
    }
  }
`;

export const VPS_DETAIL = gql`
  query ($id: ID!) {
    proxmox {
      vps(id: $id) {
        id
        name
        register_date
        expired_date
        status
        host_name
        operating_system_id
        operating_system {
          id
          name
          is_active
        }
        ip
        password
      }
      os_batch {
        nodes {
          id
          name
          is_active
        }
      }
    }
  }
`;

export const CREATE_KEY_CREDENTIAL = gql`
  mutation createKeyCred($input: NewProxmoxKeyCredential!) {
    proxmox {
      key_credentials {
        create(input: $input) {
          id
          name
          public
          user_id
        }
      }
    }
  }
`;

export const RENEW_VPS = gql`
  mutation renewVps($input: RenewCloudbankVpsInput!) {
    proxmox {
      vps {
        renew(input: $input)
      }
    }
  }
`;

export const RESET_VM_PASSWORD = gql`
  mutation resetVMPwd($id: ID!) {
    proxmox {
      vps {
        reset_vm_password(id: $id)
      }
    }
  }
`;

export const VPS_UPGRADE_PACKAGE = gql`
  mutation upgradeVps($input: UpgradeCloudbankVpsInput!) {
    proxmox {
      vps {
        upgrade(input: $input)
      }
    }
  }
`;
